export var CAMPAIGN_TYPE;
(function (CAMPAIGN_TYPE) {
    CAMPAIGN_TYPE["STANDARD"] = "STANDARD";
    CAMPAIGN_TYPE["ROUTE"] = "ROUTE";
    CAMPAIGN_TYPE["GEOFENCE"] = "GEOFENCE";
})(CAMPAIGN_TYPE || (CAMPAIGN_TYPE = {}));
